import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

export default function useQuery<T>(): T {
  const { search } = useLocation();
  return useMemo(() => queryString.parse(search.split('?')[1] || '') as unknown as T, [search]);
}
